import React from 'react';
import Countdown from 'react-countdown';
import { useSelector } from 'react-redux'
import HtmlToReact, { Parser as HtmlToReactParser } from 'html-to-react';
import RenderedHtmlContent from 'src/shared/virtual_congress/components/rendered_html_content'

export default function WaitingScreenText({ text, videoRoom, videoRoomEvent, ...props }) {

  const tagOwner = useSelector(state => state.tagOwner)
  const placeholders = {
    videoRoom: videoRoom,
    tagOwner: tagOwner,
    videoRoomEvent: videoRoomEvent
  }

  return (
    <div className="flave-video-container">
      <div style={{width: "100%", minHeight: "100px"}} className="waiting_screen_text text-center">
        <RenderedHtmlContent html={text} placeholders={placeholders}/>
      </div>
      {props.renderCustomContent != "false" && 
        <>
          {props.children}
        </>
      }
    </div>
  )
}

